(function () {
  'use strict';

  angular
    .module('component.addtoquotation-advanced', [])
    .component('buttonAddToQuotationAdvanced', {
      bindings: {
        isProductButton: '<?',
        id: '<idProduct',
        isPrimary: '<',
        url: '@productUrl',
        titleTxt: '@',
        titleAdd: '@',
        tooltipAdd: '@',
        tooltipChoice: '@?',
        message: '@',
        isQuickAdd: '<?'
      },
      templateUrl: 'component.addtoquotation-advanced.tpl',
      /* @ngInject */
      controller: ["$scope", "$location", "AppService", "ModalService", function ($scope, $location, AppService, ModalService) {
        var ctrl = this;


        ctrl.$onInit = function () {
          ctrl.tooltip = !ctrl.isPrimary && ctrl.isProductButton ? ctrl.tooltipChoice : ctrl.tooltipAdd;
        };

        AppService.getParams()
          .then(function (params) {
            ctrl.isLogged = params.IsLogged ? 1 : 0;
          })
          .catch(function (error) {
            console.error(error);
          });

        ctrl.quotationConnect = function (url) {
          ctrl.isLogged = true;
          ctrl.addToQuotation(url);
        };

        ctrl.addToQuotation = function (redirect) {
          if (!ctrl.isPrimary) {
            if (!ctrl.isProductButton) openQuickView();
            return;
          }

          ctrl.loading = true;

          if (ctrl.isLogged) {
            ModalService.show(
              '/Template/Product/ModalAddToQuotation' + '?' + (new Date().getTime()),
              {
                idProduct: ctrl.id,
                quantity: $scope.$parent.productCtrl.quantity,
                toastMessage: decodeURI(ctrl.titleAdd),
                redirect: redirect
              },
              null,
              'modalAddToQuotationCtrl',
              null,
              null,
              null,
              null,
              function () {
                ctrl.loading = false;
              }
            );
          } else {
            ModalService.show(
              '/Template/Authentication/ModalAuthentication',
              {
                message: ctrl.message,
                url: $location.path(),
                action: function (redirectUrl) {
                  ctrl.quotationConnect(redirectUrl);
                }
              },
              null,
              'loginModalCtrl',
              null,
              null,
              null,
              null,
              function () {
                ctrl.loading = false;
              }
            );
          }
        };

        $scope.$on('login', function () {
          ctrl.isLogged = true;
        });

        $scope.$on('logout', function () {
          ctrl.isLogged = false;
        });

        // Functions
        function openQuickView() {
          ModalService.show(
            '/Template/Modal/ModalQuickView',
            {
              url: ctrl.url,
              windowClass: 'modal-quick-view'
            },
            'xl',
            'modalQuickViewCtrl',
            null,
            'xl',
            {
              modalTitle: ctrl.tooltipChoice,
              isFromQuotation: true
            }
          );
        }
      }]
    })
    /* @ngInject */
    .controller('modalAddToQuotationCtrl', ["data", "device", "options", "ModalService", "AppService", "AccountService", "QuotationService", "HttpService", "toastr", function (data, device, options, ModalService, AppService, AccountService, QuotationService, HttpService, toastr) {
      var ctrl = this;
      ctrl.data = data;

      ctrl.$onInit = function () {
        ctrl.loading = true;
        ctrl.loadQuotations();
      };

      ctrl.loadQuotations = function () {
        QuotationService
          .getQuotations()
          .then(function (response) {
            ctrl.quotations = _.filter(response.results.quotations, { StateOrder: 10 });
            if (ctrl.quotations.length) {
              ctrl.selectedQuotation = ctrl.quotations[0];
            }
            refreshSelects();
            ctrl.loading = false;
          });

        HttpService
          .get({
            url: 'o-p-' + ctrl.data.idProduct
          })
          .then(function (response) {
            ctrl.product = response;
          });

        ctrl.links = AccountService.getLinks();
      };

      ctrl.add = function (idQuotation, object) {
        ctrl.loading = true;

        QuotationService
          .addToQuotation(ctrl.data.idProduct, idQuotation, object, ctrl.data.quantity)
          .then(function (response) {
            AppService.getTranslate()
              .then(function (translate) {
                ModalService.closeCurrent();
                ctrl.loading = false;
                if (response.status === 'OK') {
                  ModalService.show(
                    '/Template/Product/ModalAddToQuotationOk',
                    {
                      product: ctrl.product,
                      quotation: ctrl.newQuotationName ? ctrl.newQuotationName : ctrl.selectedQuotation.Object,
                      links: ctrl.links
                    }
                  );
                } else {
                  toastr.warning(translate.errors.TryLater, translate.errors.ErrorHasOccurred, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          })
          .catch(function (error) {
            console.error(error);
          });
      };

      function refreshSelects() {
        setTimeout(function () {
          $('.modal-content').find('select.refresh').each(function (index, el) {
            $(el).selectpicker('refresh');
          });
        });
      }
    }]);
})();
